// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title' //可以动态修改浏览器标题的插件
import 'vant-green/lib/index.css';
import VantGreen from 'vant-green'
import { Area, Popup,Loading  } from 'vant-green'
import moment from 'moment'
Vue.use(Area);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(VantGreen);
Vue.prototype.$moment=moment

Vue.use(VueWechatTitle);
Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js